import I18NextVue from 'i18next-vue'
import { initI18n } from 'www/utils'
import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import PatientProfile from 'www/vue_components/common/PatientProfile/components/common/PatientProfile.vue'
import { MOUNT_SELECTOR } from 'www/vue_components/common/PatientProfile/constants'

async function mountPatientProfile() {
  const el = document.querySelector(MOUNT_SELECTOR)

  if (el) {
    const { i18next } = await initI18n({ bundle: 'vue_components/common/PatientProfile' })

    Vue.use(I18NextVue, { i18next })

    new Vue({
      el,
      vuetify,
      render: h => h(PatientProfile),
    })
  }
}

mountPatientProfile()
